import {
  Paper,
  Table,
  TableBody as MTableBody,
  TableCell as MTableCell,
  TableContainer,
  TableHead,
  TableRow as MTableRow,
  Typography,
  Box,
} from '@mui/material';

export const Root = ({ children, sx, ...props }) => (
  <Paper sx={{ width: '100%', overflow: 'hidden', ...sx }} {...props}>
    {children}
  </Paper>
);

export const Container = ({ children, sx, ...props }) => (
  <TableContainer sx={{ ...sx }} {...props}>
    <Table stickyHeader>{children}</Table>
  </TableContainer>
);

export const Title = ({ children, sx }) => {
  const style = {
    color: '#00233C',
    fontSize: '15px',
    fontWeight: 500,
    lineHeight: '18px',
    padding: '12px',
    backgroundColor: 'white',
    borderBottom: '1px solid #EAECF0',
    ...sx,
  };
  if (typeof children !== 'string')
    return <Box sx={{ ...style }}>{children}</Box>;

  return <Typography sx={{ ...style }}>{children}</Typography>;
};

export const TableBody = ({ children, ...props }) => (
  <MTableBody {...props}>{children}</MTableBody>
);

export const TableCell = ({ children, sx, ...props }) => (
  <MTableCell
    sx={{
      height: '49px',
      padding: '3px 20px',
      whiteSpace: 'nowrap',
      paddingRight: '20px',
      color: '#6F6B7D',
      ...sx,
    }}
    {...props}>
    {children}
  </MTableCell>
);
export const TableRow = ({ children, ...props }) => (
  <MTableRow {...props}>{children}</MTableRow>
);

export const Head = ({ columns }) => (
  <TableHead
    sx={{
      textWrap: 'nowrap',
      border: 'solid 1px rgba(0,0,0,.12)',
      color: '#475467',
      zIndex: 1,
      position: 'relative',
    }}>
    <TableRow>
      {columns.map(column => (
        <TableCell
          color="#405A6D"
          key={column.field}
          align={column.align || 'center'}
          sx={{
            minWidth: column.minWidth,
            maxWidth: column.maxWidth,
            color: '#405A6D',
            backgroundColor: '#F9FAFB',
            padding: '13px 20px',
          }}>
          {column.label}
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);
